<template>
  <div class="w-full">
    <div v-for="(s, si) in form_schema" :key="si">
      <h3 v-if="show_label" class="text-2xl font-light mb-2 pb-1 border-b">{{s.label}}</h3>
      <div v-if="showValidationIndicator" class="text-center font-bold text-red-700">**Please Complete all required fields before submitting**</div>
      <div class="flex flex-wrap">
        <div v-for="(d, di) in s.fields" :key="di" class="w-full" :class="{'mb-2': true, 'p-1': true, 'w-full': (!d.width || d.width == 'full'),'md:w-1/2': d.width == 'half'}">
          <template v-if="isAdmin || !d.admin_only">
            <div v-if="d.type!='submit'" >
              <label class="block text-gray-900 text-sm font-bold mb-1" :for="d.model">
                {{d.label}}
              </label>
              <template v-if="d.type === 'multi-select'">
                <div class="relative">
                  <select v-model="s.model[d.model]" multiple class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                    <option :value="null" selected disabled>
                      {{d.placeholder}}
                    </option>
                    <option v-for="(v, vi) in d.options"  :key="vi" :value="v.value">
                      {{v.label}}
                    </option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
                </div>
              </template>
              <template v-else-if="d.type ==='select'">
                <div class="relative">
                  <select :disabled="d.disabled" v-model="s.model[d.model]" :class="['block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500', {'invalid-form-input': doValidation && d.required && !checkField(s.model, d)}, d.classes || '']" id="grid-state">
                    <option :value="null" selected disabled>
                      {{d.placeholder}}
                    </option>
                    <option v-for="(v, vi) in d.options"  :key="vi" :value="v.value" :disabled="(d.disabledOptions || []).some(disabledOption => disabledOption.value === v.value)">
                      {{v.label}} <span v-if="(d.disabledOptions || []).some(disabledOption => disabledOption.value === v.value)"></span>
                    </option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
                </div>
              </template>
              <template v-else-if="d.type ==='input'">
                <template v-if="d.inputType==='date'">
                  <date-picker v-model="s.model[d.model]" value-type="YYYY-MM-DD" :format="Localized.getDateFormat(country)"></date-picker>
                </template>
                <input v-else-if="d.inputType !== 'number'" :type="d.inputType" v-model="s.model[d.model]" :placeholder="''" class="text-input focus:outline-none focus:shadow-outline" :class="{'invalid-form-input': doValidation && d.required && !checkField(s.model, d),}">
                <input v-else type="number" v-model.number="s.model[d.model]" :placeholder="''" class="text-input focus:outline-none focus:shadow-outline" :class="{'invalid-form-input': doValidation && d.required && !checkField(s.model, d),}">
              </template>
              <template v-else-if="d.type === 'file'">
                <FilePondUploadWrapper :dataObject="s.model" :field="String(d.model)"/>
              </template>
              <textarea v-else-if="d.type=='textArea'" v-model="s.model[d.model]" :placeholder="d.label" class="text-input"/>
              <input v-else-if="d.type=='checkbox'" v-model="s.model[d.model]" class="mr-2 leading-tight" type="checkbox">
              <template v-else-if="d.type=='json'">
                <div class="">
                  <v-jsoneditor v-model="s.model[d.model]" :options="{mode:'code'}" :plus="false" height="400px" class="mb-4"/>
                </div>
              </template>
              <div>
                <a v-if="d.link" :href="d.link" target="_blank" class="link">{{d.link_label ? d.link_label : `View ${d.label}`}}</a>
                <p class="text-sm text-gray-700 mt-1" v-if="d.hint" v-html="linkify(d.hint)"></p>
              </div>
            </div>
            <template v-else>
              <button @click="d.onSubmit" class="btn btn-blue" type="button">
                {{d.buttonText}}
              </button>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!--<button @click="updateUserListUser" class="btn btn-blue" type="button">
      Add User
    </button>-->
  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import FilePondUploadWrapper from '@/components/FilePondUploadWrapper.vue'
export default {
  props: {
    form_schema: Array,
    show_label: {
      type: Boolean,
      default: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    country: {
      type: String,
      default: 'US'
    }
  },
  components: {
    VJsoneditor,
    FilePondUploadWrapper
  },
  data () {
    return {
      doValidation: false,
      showValidationIndicator: false
    }
  },
  methods: {
    checkField (object, f) {
      let isValid = true
      if (f.required) {
        if (!(f.inputType === 'number' && object[f.model] === 0) && !object[f.model]) {
          isValid = false
        }
      }
      return isValid
    },
    validateForm () {
      let isValid = true
      this.form_schema.forEach(s => {
        s.fields.forEach(f => {
          if (f.required) {
            if (!(f.inputType === 'number' && s.model[f.model] === 0) && !s.model[f.model]) {
              isValid = false
            }
          }
        })
      })

      this.doValidation = true
      this.showValidationIndicator = !isValid
      return isValid
    }
  }
}
</script>

<style>

</style>
